import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

interface SuperBannerProps {
  bannerMessage: React.ReactNode;
  dropdownContent: React.ReactNode;
}

interface SuperBannerState {
  dropdownOpen: boolean;
}

export default class SuperBanner extends React.Component<
  SuperBannerProps,
  SuperBannerState
> {
  state: SuperBannerState = {
    dropdownOpen: false,
  };

  render() {
    const bannerClass = this.state.dropdownOpen ? " open" : "";
    return (
      <div
        className={`super-banner${bannerClass}`}
        onClick={this.toggleDropdown}
      >
        <div className="top-bar">
          <div className="top-bar-content">
            <div className="banner-message">{this.props.bannerMessage}</div>
            {this.renderViewLink()}
          </div>
        </div>
        <div className="clear" />
        {this.renderDropdown()}
      </div>
    );
  }

  renderViewLink = () => {
    return (
      <div className="view-link">
        {this.state.dropdownOpen
          ? i18n.translate("super_banner.view_less")
          : i18n.translate("super_banner.view_more")}
        <i
          className={
            this.state.dropdownOpen ? "fa fa-caret-up" : "fa fa-caret-down"
          }
        />
      </div>
    );
  };

  renderDropdown = () => {
    if (!this.state.dropdownOpen) {
      return null;
    }

    return <div className="dropdown">{this.props.dropdownContent}</div>;
  };

  toggleDropdown = (e: any) => {
    e.stopPropagation();
    this.setState((prevState) => {
      return {
        dropdownOpen: !prevState.dropdownOpen,
      };
    });
  };
}
